var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { useState } from 'react';
import MediaContainer from '../Container';
function Image(_a) {
    var imageData = _a.imageData, _b = _a.aspectRatio, aspectRatio = _b === void 0 ? '' : _b, _c = _a.height, height = _c === void 0 ? '' : _c, _d = _a.width, width = _d === void 0 ? '' : _d, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.imageStyles, imageStyles = _f === void 0 ? '' : _f;
    var src = imageData.src, alt = imageData.alt;
    var _g = useState(false), isLoaded = _g[0], setIsLoaded = _g[1];
    return (_jsx(MediaContainer, __assign({ aspectRatio: aspectRatio, height: height, width: width, className: className }, { children: _jsx("img", { loading: "lazy", onLoad: function () {
                setIsLoaded(true); // Handle image load event if needed
            }, src: src, alt: alt, style: {
                width: '100%',
                height: '100%',
            }, className: clsx('h-full w-full object-cover', isLoaded ? 'opacity-100' : 'opacity-0', 'transition-opacity duration-300 ease-in-out', imageStyles) }) })));
}
export default Image;
